import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Toolbar, Grid, Card, TableCell } from "@mui/material";
import AutoCompleteDropDown from "../../../components/auto-complete-dropdown";
import NumberFormat from "../../../components/number-format";

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  padding: theme.spacing(0, 1, 0, 1),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

TableToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  category: PropTypes.any,
  onChange: PropTypes.any,
  revenue: PropTypes.any,
};

export default function TableToolbar({
  numSelected,
  category,
  onChange,
  revenue,
}: any) {
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <AutoCompleteDropDown
            data={category}
            onChange={onChange}
            label={"title"}
            dropDownDisplayLabel={"Event Name "}
            placeholder={"Event Name"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            variant="outlined"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: 40,
              borderRadius: 1,

              borderColor: "#e6e6e6",
              borderWidth: 1,
              backgroundColor: "#44B408",
            }}
          >
            <TableCell style={{ color: "#fff" }}>
              REVENUE (excludes Pay To Host txns)
            </TableCell>
            <TableCell style={{ color: "#fff" }}>
              $
              <NumberFormat total={revenue} />
            </TableCell>
          </Card>
        </Grid>
      </Grid>
    </StyledRoot>
  );
}
